import { render, staticRenderFns } from "./training-search-details.vue?vue&type=template&id=4b7799fd&"
import script from "./training-search-details.vue?vue&type=script&lang=js&"
export * from "./training-search-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports